<template>
  <v-row>
    <v-col v-for="(image, index) in bannersData" :key="index" cols="12" md="6">
      <a target="_blank" :href="image.link">
        <v-img
          height="415"
          class="rounded-lg"
          :src="image.image"
          :alt="image.title"
        />
      </a>
    </v-col>
  </v-row>
</template>

<script>
import authService from "@/services/modules/authService";

export default {
  data() {
    return {
      bannersData: []
    };
  },
  mounted() {
    this.getSliders();
  },
  methods: {
    getSliders() {
      authService.getLoginSliders("desktop_stacking").then(res => {
        this.bannersData = res.data.data;
      });
    }
  }
};
</script>

<style scoped></style>
